<script lang="ts">
	import Form from '$lib/components/Contact/Form.svelte';
	import Map from '$lib/components/Contact/Map.svelte';
	import { FAQ } from '$lib/components/Global/FAQ';
	import Help from '$lib/components/Global/Help.svelte';
	import Description from '$lib/components/SEO/Description.svelte';
	import Title from '$lib/components/SEO/Title.svelte';
	import __ from '$lib/stores/TranslationStore';
</script>

<svelte:head>
	<Title content={`${$__('Os nossos contactos')} - Poupança no Minuto`} />
	<Description
		content={$__(
			'Entre em contacto com o Poupança no Minuto e tire as suas dúvidas. Preencha o formulário, envie um e-mail ou ligue e fale com um dos nossos agentes.'
		)}
	/>
	<meta property="og:image" content="/og/open-graph-extra.png" />
</svelte:head>

<Form />
<Map />
<FAQ category="Seguros" />
<Help />
